"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInputState = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const i18n_1 = require("../../i18n");
const input_state_1 = require("./input.state");
const RE_NUMBER = /^\s*[+-]?((\.\d+)|(\d+(\.\d+)?))$/;
class NumberInputState extends input_state_1.InputState {
    static equal(value1, value2, precision) {
        if (value1 == null || value2 == null || isNaN(value1) || isNaN(value2)) {
            return value1 === value2;
        }
        return value1.toFixed(precision) === value2.toFixed(precision);
    }
    constructor(label, precision = NumberInputState.DEFAULT_PRECISION, minimumInputPrecision = NumberInputState.DEFAULT_MINIMUM_INPUT_PRECISION, options = {}) {
        super(label);
        this.hideZero = false;
        this.onBlurCallback = () => undefined;
        this.onInputCallback = () => undefined;
        this.precision = precision;
        this.minimumInputPrecision = minimumInputPrecision;
        if (options.onblur) {
            this.onBlurCallback = options.onblur;
        }
        if (options.oninput) {
            this.onInputCallback = options.oninput;
        }
    }
    formatInputValue(val) {
        if (val == null || isNaN(val)) {
            return null;
        }
        const roundedValue = core_shared_1.IkeUnit.round(val, this.precision);
        if (this.hideZero && roundedValue === 0) {
            return null;
        }
        return String(roundedValue);
    }
    parseInputValue(val) {
        const num = this.parseNumber(val);
        if (num == null) {
            this.setError(null);
            return null;
        }
        if (isNaN(num)) {
            this.setError(i18n_1.T.NUMBER_INVALID);
            return null;
        }
        const splitVal = val.split('.');
        // In order to ensure that splitVal.length is at least two, we had an empty string at the end
        splitVal.push('');
        if (splitVal[1].length < this.minimumInputPrecision) {
            this.setError((0, i18n_1.Translate)(i18n_1.T.NUMBER_IMPRECISE, { minimumInputPrecision: this.minimumInputPrecision }));
            return null;
        }
        this.setError(null);
        if (this.hideZero && num === 0) {
            return null;
        }
        return num;
    }
    parseNumber(val) {
        if (val.trim().length === 0) {
            return null;
        }
        if (val.match(RE_NUMBER) == null) {
            return NaN;
        }
        return Number(val);
    }
    onBlur(e) {
        this.onBlurCallback(e);
    }
    onInput(e) {
        this.onInputCallback(e);
    }
}
exports.NumberInputState = NumberInputState;
NumberInputState.DEFAULT_PRECISION = 3;
NumberInputState.DEFAULT_MINIMUM_INPUT_PRECISION = 0;
//# sourceMappingURL=number.input.state.js.map